module.exports = __webpack_public_path__ + "assets/img/zh_logo@2x.7b829b79.png";